import { IServiceChangePasswordRequest } from "../Domain/IServiceChangePassword";
import { RepositoryMain } from "../Domain/RepositoryMain";

export class UseCaseChangePassword {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(params: IServiceChangePasswordRequest) {
        return await this.repository.postChangePassword(params)
    }
}